// extracted by mini-css-extract-plugin
module.exports = {"cms":"Pedagogique_cms__RM2T4","wrapper":"Pedagogique_wrapper__nAzta","title":"Pedagogique_title__N2LBs","image":"Pedagogique_image__S6Ncp","text":"Pedagogique_text__RqF2U"};